/* Ottomara 1:1 redesign (6 Oct 2026): shared catalogue, chair drawing and helpers.
   Ported from the "Ottomara.com — Made-to-Order Redesign" design artifact.
   8 Oct 2026: one ship-by calculation and format for the whole site, and the same "Ships by" / "Order type"
   line-item properties on every add to cart (builder, home cards, product page). */
(function () {
  var ALL = ['anth', 'latte', 'jeans', 'yucca', 'chestnut', 'goldblack', 'carrot', 'melon', 'turq', 'green'];
  var CAT = {
    models: [
      { id: 'bosphorus', name: 'Bosphorus', label: 'Bosphorus', code: 'BOS', featured: 399, pair: 379, custom: 449 },
      { id: 'chillgo', name: 'ChillGo', label: 'ChillGo', code: 'CHG', featured: 279, pair: 249, custom: 329 }
    ],
    frames: [
      { id: 'teak', name: 'Teak', code: 'TK', base: '#8A5A33', hi: '#C9935E', sw: 'linear-gradient(135deg,#C08850 0%,#8A5530 55%,#B77A45 100%)' },
      { id: 'anth', name: 'Anthracite', code: 'AN', base: '#3B3F43', hi: '#79808A', sw: 'linear-gradient(135deg,#5E6367,#303336)' },
      { id: 'silver', name: 'Silver', code: 'SV', base: '#A5AAAF', hi: '#F2F4F5', sw: 'linear-gradient(135deg,#F1F3F4,#A3A8AD 55%,#D5D9DC)' },
      { id: 'capp', name: 'Cappuccino', code: 'CP', base: '#7A6F63', hi: '#B5A994', sw: 'linear-gradient(135deg,#A99C8A,#6E6356)' }
    ],
    meshes: [
      { id: 'anth', name: 'Anthracite', code: 'AN', hex: '#5A5C5F' },
      { id: 'latte', name: 'Latte', code: 'LT', hex: '#ECE5D5' },
      { id: 'jeans', name: 'Jeans', code: 'JN', hex: '#848D9B' },
      { id: 'yucca', name: 'Yucca', code: 'YC', hex: '#A9B46A' },
      { id: 'chestnut', name: 'Chestnut', code: 'CH', hex: '#958A80' },
      { id: 'goldblack', name: 'Gold Black', code: 'GB', hex: '#5E4A41', fleck: 'rgba(214,172,96,0.6)' },
      { id: 'carrot', name: 'Carrot', code: 'CR', hex: '#EE7F38' },
      { id: 'melon', name: 'Melon', code: 'ML', hex: '#EEC437' },
      { id: 'turq', name: 'Turquoise', code: 'TQ', hex: '#79B4C6' },
      { id: 'green', name: 'Dark Green', code: 'DG', hex: '#3A4E47' }
    ],
    avail: {
      // 6 Oct 2026: founders confirmed any sling can go on any frame.
      bosphorus: { teak: ALL, anth: ALL, silver: ALL, capp: ALL },
      chillgo: { teak: ALL, anth: ALL, silver: ALL, capp: ALL }
    },
    // 8 Oct 2026 (Nick): Founders' Favorites cut to 3 colorways on both models, the bulk-order set.
    featured: {
      bosphorus: ['anth-anth', 'anth-latte', 'teak-anth'],
      chillgo: ['anth-anth', 'anth-latte', 'teak-anth']
    }
  };
  function find(list, id) { for (var i = 0; i < list.length; i++) if (list[i].id === id) return list[i]; return null; }
  function byName(list, name) { for (var i = 0; i < list.length; i++) if (list[i].name.toLowerCase() === String(name).toLowerCase()) return list[i]; return null; }

  function chair(model, recline, o) {
    var far, near, cross, floor, back, seat, caps, hinge, railMid, legTop;
    var i = 2.5;
    if (model === 'chillgo') {
      var Sd = 46, W = 55, hr = 20, hf = 23, Lb = 52, a = 62 * Math.PI / 180;
      var zs = function (x) { return hr + (hf - hr) * x / Sd; };
      var tx = -Lb * Math.cos(a), tz = hr + Lb * Math.sin(a), ca = Math.cos(a), sa = Math.sin(a);
      var side = function (y) { return [[[0, y, hr], [Sd, y, hf]], [[0, y, hr], [tx, y, tz]], [[7, y, zs(7)], [1, y, 0]], [[Sd - 4, y, zs(Sd - 4)], [Sd + 4, y, 0]]]; };
      far = side(W); near = side(0);
      cross = [[[Sd, 0, hf], [Sd, W, hf]], [[tx, 0, tz], [tx, W, tz]], [[0, 0, hr], [0, W, hr]]];
      floor = [[[1, 0, 0], [1, W, 0]], [[Sd + 4, 0, 0], [Sd + 4, W, 0]]];
      back = [[tx + i * ca, i, tz - i * sa], [tx + i * ca, W - i, tz - i * sa], [0, W - i, hr], [0, i, hr]];
      seat = [[0, i, hr], [0, W - i, hr], [Sd - i, W - i, zs(Sd - i)], [Sd - i, i, zs(Sd - i)]];
      caps = [[tx, 0, tz], [tx, W, tz], [Sd, 0, hf], [Sd, W, hf], [0, 0, hr], [0, W, hr], [1, 0, 0], [Sd + 4, 0, 0]];
      hinge = [0, 0, hr]; railMid = [Sd * 0.55, 0, zs(Sd * 0.55)]; legTop = [Sd - 4, 0, zs(Sd - 4)];
    } else {
      var Ls = 122, Lb2 = 68, hs = 25, W2 = 58, a2 = recline * Math.PI / 180;
      var tx2 = -Lb2 * Math.cos(a2), tz2 = hs + Lb2 * Math.sin(a2), ca2 = Math.cos(a2), sa2 = Math.sin(a2);
      var legs = [[8, -9], [Ls * 0.52, 0], [Ls - 6, 9]];
      var side2 = function (y) { var s = [[[0, y, hs], [Ls, y, hs]], [[0, y, hs], [tx2, y, tz2]]]; legs.forEach(function (l) { s.push([[l[0], y, hs], [l[0] + l[1], y, 0]]); }); return s; };
      far = side2(W2); near = side2(0);
      cross = [[[Ls, 0, hs], [Ls, W2, hs]], [[tx2, 0, tz2], [tx2, W2, tz2]], [[0, 0, hs], [0, W2, hs]]];
      near.push([[16, 0, hs], [tx2 * 0.42, 0, hs + (tz2 - hs) * 0.42]]);
      floor = legs.map(function (l) { return [[l[0] + l[1], 0, 0], [l[0] + l[1], W2, 0]]; });
      back = [[tx2 + i * ca2, i, tz2 - i * sa2], [tx2 + i * ca2, W2 - i, tz2 - i * sa2], [0, W2 - i, hs], [0, i, hs]];
      seat = [[0, i, hs], [0, W2 - i, hs], [Ls - i, W2 - i, hs], [Ls - i, i, hs]];
      caps = [[tx2, 0, tz2], [tx2, W2, tz2], [Ls, 0, hs], [Ls, W2, hs], [0, 0, hs], [0, W2, hs]];
      legs.forEach(function (l) { caps.push([l[0] + l[1], 0, 0]); });
      hinge = [0, 0, hs]; railMid = [Ls * 0.72, 0, hs]; legTop = [Ls * 0.52, 0, hs];
    }
    var S = o.S;
    var pr = function (p) { return [S * (p[0] + 0.42 * p[1]), S * (0.17 * p[0] - 0.40 * p[1] - 0.95 * p[2])]; };
    var flat = [];
    far.concat(near, cross, floor).forEach(function (seg) { seg.forEach(function (p) { flat.push(p); }); });
    back.forEach(function (p) { flat.push(p); }); seat.forEach(function (p) { flat.push(p); });
    var x0 = 1e9, x1 = -1e9, y0 = 1e9, y1 = -1e9;
    flat.map(pr).forEach(function (p) { x0 = Math.min(x0, p[0]); x1 = Math.max(x1, p[0]); y0 = Math.min(y0, p[1]); y1 = Math.max(y1, p[1]); });
    var ox = o.cx - (x0 + x1) / 2, oy = o.cy - (y0 + y1) / 2;
    var P = function (p) { var q = pr(p); return [q[0] + ox, q[1] + oy]; };
    var f = function (n) { return n.toFixed(1); };
    var d = function (segs) { return segs.map(function (s) { return 'M' + s.map(function (p) { var q = P(p); return f(q[0]) + ' ' + f(q[1]); }).join(' L'); }).join(' '); };
    var poly = function (pl) { return pl.map(function (p) { var q = P(p); return f(q[0]) + ',' + f(q[1]); }).join(' '); };
    var r = o.cap || 5;
    var capD = r ? caps.map(function (p) { var q = P(p); return 'M' + f(q[0] - r) + ' ' + f(q[1]) + ' a' + r + ' ' + r + ' 0 1 0 ' + (2 * r) + ' 0 a' + r + ' ' + r + ' 0 1 0 ' + (-2 * r) + ' 0'; }).join(' ') : '';
    var fp = []; floor.forEach(function (s) { s.forEach(function (p) { fp.push(P(p)); }); });
    var fx0 = 1e9, fx1 = -1e9, fy0 = 1e9, fy1 = -1e9;
    fp.forEach(function (p) { fx0 = Math.min(fx0, p[0]); fx1 = Math.max(fx1, p[0]); fy0 = Math.min(fy0, p[1]); fy1 = Math.max(fy1, p[1]); });
    var mid = function (A, B) { return [(A[0] + B[0]) / 2, (A[1] + B[1]) / 2, (A[2] + B[2]) / 2]; };
    var out = {
      far: d(far), near: d(near.concat(cross)), floor: d(floor), caps: capD,
      all: d(far.concat(near, cross, floor)), back: poly(back), seat: poly(seat),
      shadow: { cx: f((fx0 + fx1) / 2), cy: f((fy0 + fy1) / 2 + 2), rx: f((fx1 - fx0) / 2 + 10), ry: f((fy1 - fy0) / 2 + 2) },
      pt: { hinge: P(hinge), rail: P(railMid), legTop: P(legTop), seatC: P(mid(seat[0], seat[2])), backTop: P([(back[0][0] + back[1][0]) / 2, (back[0][1] + back[1][1]) / 2 + 6, (back[0][2] + back[1][2]) / 2]), backFar: P(back[1]) }
    };
    var B0 = P(back[0]), B1 = P(back[1]), B3 = P(back[3]);
    var at = function (u, v) { return [B0[0] + u * (B1[0] - B0[0]) + v * (B3[0] - B0[0]), B0[1] + u * (B1[1] - B0[1]) + v * (B3[1] - B0[1])]; };
    var e0 = at(0.05, 0.05), eu = at(0.95, 0.05), ev = at(0.05, 0.56);
    out.emb = 'matrix(' + [(eu[0] - e0[0]) / 200, (eu[1] - e0[1]) / 200, (ev[0] - e0[0]) / 120, (ev[1] - e0[1]) / 120, e0[0], e0[1]].map(function (n) { return n.toFixed(4); }).join(' ') + ')';
    return out;
  }

  function paint(svg, g) {
    if (!svg) return;
    svg.querySelectorAll('[data-p]').forEach(function (el) {
      var k = el.getAttribute('data-p');
      if (k === 'back' || k === 'seat') el.setAttribute('points', g[k]);
      else if (k === 'shadow') { el.setAttribute('cx', g.shadow.cx); el.setAttribute('cy', g.shadow.cy); el.setAttribute('rx', g.shadow.rx); el.setAttribute('ry', g.shadow.ry); }
      else if (k === 'emb') el.setAttribute('transform', g.emb);
      else el.setAttribute('d', g[k]);
    });
  }

  // One ship-by date for the whole site: today + 120 days, formatted "Feb 5, 2027".
  // The product page's server-rendered date uses the same format and is overwritten with this one on load.
  function shipBy(days) {
    var t = new Date(); t.setDate(t.getDate() + (days || 120));
    return t.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  }
  var ORDER_TYPE = 'Pre-order — cancel any time before shipping for a full refund';
  function preorderProps(extra) {
    var p = { 'Ships by': shipBy(120), 'Order type': ORDER_TYPE };
    if (extra) for (var k in extra) if (Object.prototype.hasOwnProperty.call(extra, k)) p[k] = extra[k];
    return p;
  }
  function money(n) { return '$' + Number(n).toLocaleString('en-US'); }

  // Builder and home analytics: Shopify customer events (web pixels), plus GA4 and Meta when they are loaded.
  function track(name, data) {
    data = data || {};
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, data); } catch (e) {}
    try { if (typeof window.gtag === 'function') window.gtag('event', name, data); } catch (e) {}
    try { if (typeof window.fbq === 'function') window.fbq('trackCustom', name, data); } catch (e) {}
  }

  function setCartCount(n) {
    document.querySelectorAll('[data-ot-cart-count]').forEach(function (el) { el.textContent = n; });
    document.querySelectorAll('[data-ot-cart-btn]').forEach(function (el) { el.setAttribute('aria-label', 'Cart, ' + n + (n === 1 ? ' item' : ' items')); });
  }
  function refreshCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { setCartCount(c.item_count); return c; });
  }

  window.OT = { cat: CAT, find: find, byName: byName, chair: chair, paint: paint, shipBy: shipBy, preorderProps: preorderProps, track: track, money: money, refreshCart: refreshCart, setCartCount: setCartCount, shipDays: 120 };

  function stamp() {
    var sb = shipBy(window.OT.shipDays);
    document.querySelectorAll('[data-ot-shipby]').forEach(function (el) { el.textContent = sb; });
    document.querySelectorAll('input[name="properties[Ships by]"]').forEach(function (el) { el.value = sb; });
  }
  document.addEventListener('DOMContentLoaded', stamp);
  // Product forms re-render when the variant changes; keep their hidden date in step.
  document.addEventListener('variant:update', function () { setTimeout(stamp, 0); });
  document.addEventListener('submit', function (e) { if (e.target && e.target.querySelector && e.target.querySelector('input[name="properties[Ships by]"]')) stamp(); }, true);
})();
